<ng-container *transloco="let t; prefix: scope">
  @if (store.agentsLoading()) {
    <!-- the skeletons stand in at the height of what replaces them, so the map below stays out of the viewport until it is scrolled to -->
    <rma-skeleton-grid [bones]="1" heightClass="h-16 mb-8 w-1/2" />
    <rma-skeleton-grid [bones]="1" heightClass="h-68 mt-2 mb-4" />
    <div class="flex flex-col gap-6">
      <rma-skeleton-grid [bones]="1" heightClass="h-84" />
      <rma-skeleton-grid [bones]="1" heightClass="h-136" />
      <rma-skeleton-grid [bones]="1" heightClass="h-15" />
      <rma-skeleton-grid [bones]="1" heightClass="h-96" />
    </div>
  } @else if (store.agentsError(); as agentsError) {
    <h1>{{ t('no-agents.title') }}</h1>
    <rma-callout class="mt-4" [message]="agentsError" />
  } @else {
    @let agents = store.agents();
    @let location = store.location();
    @if (location && !agents.length) {
      <rma-no-agents [isLocation]="true" />
    } @else {
      @if (location) {
        <h1>{{ t('locationTitle', { count: agents.length, location: location.name }) }}</h1>
      }
      <rma-agent-cards-row
        [agents]="agents"
        [showAddSlot]="!location"
        [rmaYieldTo]="mapSection()?.nativeElement"
        (removeAgent)="store.remove($event)"
      />
    }
    @if (agents.length) {
      <div class="flex flex-col gap-6">
        <rma-overall-information-section [agents]="agents" />
        <rma-login-gate [gated]="store.gated()" [showCard]="store.showLoginCard()">
          <rma-sales-performance-section
            [agents]="agents"
            [buyersAgentEnabled]="buyersAgentEnabled()"
            [propertyTypes]="store.propertyTypes()"
            [selectedPropertyType]="store.effectivePropertyType()"
            (propertyTypeChange)="store.setPropertyType($event)"
            gate-teaser
          />
          <rma-find-my-agent-cta-banner />
          <rma-compare-agents-map-section [agents]="agents" [gated]="store.gated()" />
        </rma-login-gate>
      </div>
    }
  }
</ng-container>
